<template>
  <v-layout column>
    <v-row class="page-header-block">
      <h1 class="page-header-block__header">projects</h1>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="projects"
      :search="search"
      class="elevation-1"
      style="height: 100%"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>

          <v-spacer></v-spacer>

          <v-btn to="/projects/new">
            <span class="mr-2">Add Project</span>
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="exportProject(item)">mdi-download</v-icon>
        <v-icon small class="mr-2" @click="editProject(item)">mdi-pencil</v-icon>
        <v-icon small @click="deleteProject(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
  </v-layout>
</template>

<script>
import { map } from "lodash";
import http from "src/util/http";

export default {
  name: "Projects",
  data() {
    this.getProjects();

    return {
      search: "",
      projects: [],
      headers: [
        { text: "Project", value: "projectName" },
        { text: "Product", value: "productName" },
        { text: "Company", value: "companyName" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  methods: {
    async getProjects() {
      this.$store.dispatch("updateShowLoading", true);

      const { data: projects } = await http().get("projects");
      this.projects = map(projects, ({ id, fileHeader, contentHeader }) => ({
        id,
        projectName: contentHeader.name,
        productName: fileHeader.productName,
        companyName: fileHeader.companyName,
      }));

      this.$store.dispatch("updateShowLoading", false);
    },
    async deleteProject(project) {
      if (
        await this.$confirm("Are you sure you want to delete this project?")
      ) {
        await http().delete(`projects/${project.id}`);
        await this.getProjects();
      }
    },
    editProject({ id }) {
      this.$router.push({ path: `projects/${id}` });
    },
    async exportProject({ id }) {
      window.open(
        `${process.env.VUE_APP_API_BASE_URL}/projects/${id}/download`
      );
    },
  },
};
</script>
